/**
 * PowerSavingContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled power saving container.
 */
const PowerSavingContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  flex-direction: row;
  position: relative;
  left: ${72 * Screen.widthRatio}px;
  top: ${362 * Screen.widthRatio}px;
`;

export default withOpacity(PowerSavingContainer);
